import { createCloudFunctionClient } from "@repo/core/services/apiClient";

const expressServerApiClient = createCloudFunctionClient("api", "clinic");
export const SMILE_SIMULATION_SHARED_WATERMARK_STORAGE_PATH =
  "smile-simulation/shared/watermark.png";

export const getSmileSimulationClinicWatermarkStoragePath = (
  clinicId: string,
) => `smile-simulation/${clinicId}/branding/watermark.png`;

export const getSmileSimulationSignedReadUrl = async (filePath: string) => {
  const response = await expressServerApiClient.post(
    "/shared/gcs/firebase/getSignedReadUrl",
    {
      filePath,
    },
  );

  const signedUrl = response.data?.signedUrl;

  if (typeof signedUrl !== "string" || !signedUrl.trim()) {
    throw new Error(`Signed URL not found for Firebase path: ${filePath}`);
  }

  return signedUrl;
};

const doesSmileSimulationSignedReadUrlExist = async (signedUrl: string) => {
  try {
    const response = await fetch(signedUrl, {
      cache: "no-store",
      method: "HEAD",
    });

    if (response.ok) {
      return true;
    }
  } catch (error) {
    console.debug("Signed URL HEAD check failed, retrying with GET:", error);
  }

  try {
    const response = await fetch(signedUrl, {
      cache: "no-store",
      method: "GET",
    });

    return response.ok;
  } catch {
    return false;
  }
};

export const getOptionalSmileSimulationSignedReadUrl = async (
  filePath: string,
) => {
  try {
    const signedUrl = await getSmileSimulationSignedReadUrl(filePath);
    const exists = await doesSmileSimulationSignedReadUrlExist(signedUrl);

    return exists ? signedUrl : null;
  } catch {
    return null;
  }
};

export const getSmileSimulationWatermarkSignedUrls = async (
  clinicId: string | null,
) => {
  const [clinicWatermarkUrl, serviceWatermarkUrl] = await Promise.all([
    clinicId
      ? getOptionalSmileSimulationSignedReadUrl(
          getSmileSimulationClinicWatermarkStoragePath(clinicId),
        )
      : Promise.resolve(null),
    getOptionalSmileSimulationSignedReadUrl(
      SMILE_SIMULATION_SHARED_WATERMARK_STORAGE_PATH,
    ),
  ]);

  return {
    clinicWatermarkUrl,
    serviceWatermarkUrl,
  };
};

export const uploadSmileSimulationClinicWatermark = async (
  imageBlob: Blob,
): Promise<{
  clinicId: string;
  path: string;
}> => {
  const formData = new FormData();
  formData.append("image", imageBlob, "watermark.png");

  const response = await expressServerApiClient.post(
    "/veneer/simulation/watermark",
    formData,
  );

  return response.data;
};
